/* eslint no-unused-vars: ['error', { 'varsIgnorePattern': 'slick' }] */
import slick from 'slick-carousel';

export default () => {

  let $img;

  if ($('.carousel').length) {

    $('.carousel').map((index, el) => {
      $(el).attr('data-carousel-id', index);

      const $carousel = $('.carousel[data-carousel-id="' + index + '"]');

      $carousel.find('.carousel-slides-inner').slick({
        dots: false,
        appendArrows: $carousel.find('.carousel-slides-nav'),
        infinite: false,
        asNavFor: $carousel.find('.carousel-bg-slides'),
        nextArrow: $carousel.find('.carousel-slides-nav-next'),
        prevArrow: $carousel.find('.carousel-slides-nav-prev')
      });

      $carousel.find('.carousel-bg-slides').slick({
        dots: false,
        arrows: false,
        infinite: false,
        accessibility: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        asNavFor: $carousel.find('.carousel-slides-inner')
      });

      $img = $carousel.find('.carousel-slide img');

      $(window).on('resize', () => {
        sizeAndPositionThings();
      });

      sizeAndPositionThings();

      function sizeAndPositionThings() {
        const imgHeight = $img.height();
        const imgWidth = $img.width();
        const leftPos = $('.carousel-slides-inner').offset().left;

        if ($(window).width() < 600) {
          $('.carousel-bg-slides').height(imgHeight - 30).width((imgHeight - 30) * 700 / 465);
        } else {
          $('.carousel-bg-slides').height(imgHeight - 60).width((imgHeight - 60) * 700 / 465);
        }

        if ($(window).width() < 900) {
          $('.carousel-slides-nav').css('top', imgHeight);
          $('.carousel-slides-shadow')
            .height(imgHeight - 20)
            .css({
              'left': leftPos,
              'right': leftPos + 20
            })
          ;

          $('.carousel-bg-slides').css('left', 'calc(100% - ' + leftPos + 'px)');
          $('.carousel-content').css('min-height', $('.carousel-title').width());
        } else {
          $('.carousel-content').css('min-height', $('.carousel-slides').outerHeight());
          $('.carousel-slides-nav').height($('.carousel-slide img').height());
          $('.carousel-slides-shadow').height(imgHeight - 20).width(imgWidth - 20)
          ;
        }
      }
    });

  }

};
